import type { AccountChoice } from "./prompts";
import type { Identity, Profile } from "./types";

/** The profile's default business account as an Identity, or null when none is set. */
export function profileAccount(profile: Profile): Identity | null {
	return profile.accountId || profile.accountTitle || profile.accountRoute
		? {
				id: profile.accountId,
				title: profile.accountTitle,
				route: profile.accountRoute,
			}
		: null;
}

/** Appends the selectable accounts to an error message so agents can self-correct. */
export function availableAccountsMessage(
	message: string,
	accounts: AccountChoice[],
): string {
	if (accounts.length === 0) return `${message} Available: none.`;
	return `${message} Available: ${accounts
		.map((account) => `${account.id} (${account.title})`)
		.join(", ")}.`;
}
